<template>
    <AttachMaterials></AttachMaterials>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const AttachMaterials = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/EngineeringWorkbench/AttachMaterials.vue"
    )
);

export default {
    name: "Project_HelpAttachMaterials", //The name you are in should not equal the name of the component you are importing.
    components: { AttachMaterials, AuthLayout },
};
</script>
